<template>
    <div>
        <div :id="$id('reportrange')"
             style="background: #fff; cursor: pointer; padding: 5px 10px; border: 1px solid #ccc; width: 100%">
            <i class="fa fa-calendar"></i>&nbsp;
            <span></span> <i class="fa fa-caret-down"></i>
        </div>
        <input type="hidden" name="from" :id="$id('from')" value=""/>
        <input type="hidden" name="to" :id="$id('to')" value=""/>
        <input type="hidden" :id="$id('selectedValue')"/>
    </div>
</template>

<script>

    export default {
        name: "DateRangePicker",

        beforeMount: function(){

        },
        mounted: function(){
            var start = moment().subtract(29, 'days');
            var end = moment();

            let reportrangeId = this.$id('reportrange');
            let fromId = this.$id('from');
            let toId = this.$id('to');

            function cb(start, end) {
                $('#'+reportrangeId+' span').html(start.format('YYYY-MM-D') + '_' + end.format('YYYY-MM-DD'));
                $("#"+fromId).val(start.format('YYYY-MM-D'));
                $("#"+toId).val(end.format('YYYY-MM-DD'));
            }

            $('#'+reportrangeId).daterangepicker({
                startDate: start,
                endDate: end,
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }
            }, cb);
            cb(start, end);
        }
    }
</script>